import {checkIfNeedAgeVerification, reinitializeSession} from "@/api/age_verification";
import store from "@/store";

export const ageVerificationCheck = async () => {
    const response = await checkIfNeedAgeVerification()

    await store.dispatch('ageVerification/setLink', response.data.verification_link, { root: true })
    await store.dispatch('ageVerification/setStatus', response.data.status, { root: true })
    await store.dispatch('ageVerification/setAttempts', response.data.attempts, { root: true })

    return response.data

}

export const reinitialize = async () => {
    const response = await reinitializeSession()

    await store.dispatch('ageVerification/setLink', response.data.verification_link, { root: true })
    await store.dispatch('ageVerification/setStatus', response.data.status, { root: true })
    await store.dispatch('ageVerification/setAttempts', response.data.attempts, { root: true })

    return response.data

}